import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const PricingContext = createContext(null);

// Provides marketing prices from the centralized pricing table.
// getPrice(key) returns the active entry (with a rendered .display) or null
// when the price is missing or inactive, so callers can hide gracefully.
export function PricingProvider({ children }) {
  const [prices, setPrices] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/pricing`)
      .then((res) => {
        if (active) setPrices(res.data?.prices || {});
      })
      .catch(() => {
        if (active) setPrices({});
      })
      .finally(() => {
        if (active) setLoaded(true);
      });
    return () => {
      active = false;
    };
  }, []);

  const getPrice = (key) => prices[key] || null;
  const getDisplay = (key) => prices[key]?.display || null;

  return (
    <PricingContext.Provider value={{ prices, loaded, getPrice, getDisplay }}>
      {children}
    </PricingContext.Provider>
  );
}

export function usePricing() {
  const ctx = useContext(PricingContext);
  if (!ctx) throw new Error("usePricing must be used within a PricingProvider");
  return ctx;
}
